import React from "react";
import { Image } from "@fluentui/react";
import { AppTheme } from "./App";

interface HeaderProps {
  theme: AppTheme;
}

const Header: React.FC<HeaderProps> = (props) => {
  if (props.theme === "tomtbola") {
    return (
      <Image
        src="./tomtbola-logo.svg"
        styles={{ image: { width: "100%", maxHeight: "15vh" } }}
      />
    );
  }
  return (
    <div className="header-container">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <h1 className="geist-logo">FIKAHJULET</h1>
      <svg
          id="Layer_1" 
        xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 2036.2 1915.1" 
          width="48px"
          height="48px"
          style={{ marginLeft: '0.8rem', marginBottom: '0.3rem' }}
          className="coffee-icon"
        >
          <g id="Generative_Object">
            <path d="M0,1692.2l2036.2,1.8c-66.3,74-362,162.9-376.2,178.4-8.7,9.5,4.1,35-31.8,38.9-185.5-9.5-1142.4,12.4-1218.6,0-47.5-7.7-17.4-25.6-38.9-42.4-16.3-12.7-330.6-112.4-370.9-176.6Z"/>
            <path d="M1094.9.4c2.4-.6,7.4-.7,8.8,1.8-103,232.1,281.3,376.8-58.3,616.3,55.1-87.9,40.5-139.7,5.3-231.3-43.5-113.5-137.1-192.2-38.9-314.4,7.2-9,77.7-71,83-72.4Z"/>
            <path d="M886.5,184c-31.4,186.8,256.2,238.9,45.9,448.6,75.9-197.1-254.2-253.5-45.9-448.6Z"/>
            <path d="M1700.7,811l1.8-125.4H328.5c2.7,351.9,53.4,719.4,328.5,964.2h717l158.9-180.1c61.5-54.1,304.3-150.7,393.8-333.8,87.1-178.2-16.9-370.5-226.1-325ZM1610.6,1303.7c40.9-123,63.3-251,79.5-379.7,6.1-12.9,58.5-32.6,72.4-33.6,39.1-2.6,76.4,20,93.6,54.8,86.2,174.5-219.7,373.8-245.5,358.5Z"/>
        </g>
      </svg>
      </div>
    </div>
  );
};
export default Header;
